import { render, staticRenderFns } from "./BottomInfo.vue?vue&type=template&id=69630727&scoped=true&"
import script from "./BottomInfo.vue?vue&type=script&lang=ts&"
export * from "./BottomInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BottomInfo.vue?vue&type=style&index=0&id=69630727&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69630727",
  null
  
)

export default component.exports